import axios from 'axios';

const instance = axios.create({
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

export default function (requestData) {
  return instance(requestData).catch(err=>{
      if(err.response && (err.response.status === 401 || err.response.status === 403)) {
          document.cookie = "jwt-access-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.href = '/login';
      }
      return Promise.reject(err);
  });
}



// WEBPACK FOOTER //
// ./src/utils/RequestManager.js